module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/PR-165fcc79b619d6e088783b45321ad23a.png";